import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ShareTwoCentsContent from '../../components/Pages/ShareYourTwoCents';

const { displayName } = config;

export default function ShareYourTwoCents(): React.ReactElement {
  document.title = `${displayName}: Share Your Two Cents`;

  return (
    <Layout>
      <ShareTwoCentsContent />
    </Layout>
  );
}
